import React from "react";
import "./Contact.css";
import axios from "axios";
import { useState } from "react";
import Forfmsubmit from "../Loader/Forfmsubmit";
import ManualAlertpage from "../Alert/ManualAlertpage";


const ApplyCourse = () => {

  // form submission 

  const [submissionpage, setsubmissionpage] = useState(false); // for enable Submission page 
  const [Submissiondata, setSubmissiondata] = useState({})

  const toggleFn = () => {
    setsubmissionpage(!submissionpage);
  }

  const [error, seterror] = useState("")
  const [loader, setloader] = useState(false)
  const [data, setData] = useState({
    fullname: "", number: "", email: "", course: "", message: ""
  })

  const handlechange = async (e) => {
    const { name, value } = e.target
    setData({ ...data, [name]: value })
  }

  const handleerror = () => {
    let validate = true

    if (data.number.length != 10) {
      seterror("Number must in 10 digits")
      validate = false
    }
    return validate
  }

  const handlesubmit = async (e) => {
    e.preventDefault()

    if (handleerror()) {

      seterror("")
      setloader(true)
      try {
        const response = await fetch("https://icoeess-backend-06-feb-2025-icoessbackend.onrender.com/api/applyinquiry", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        });

        const result = await response.json()

        if (result.status == "success") {
          setsubmissionpage(true)
          setSubmissiondata({
            message: "Thank you for enquiring us!!",
            context: `A confirmation E-mail has been sent on <strong>${data.email}</strong>. We will be in touch with you shortly.`,
            btnname: "Ok"
          })

          setData({ fullname: "", number: "", email: "", course: "" })
        }
        else {
          seterror("Something else please try again")
        }

      } catch (err) {
        seterror("There was an error while submitting your application. Please try again.");
        console.error("Fetching Error:", err);
      } finally {
        setloader(false)
      }
    }
  }

  if (loader) {
    return <Forfmsubmit />
  }

  return (
    <>
      <section className="apply-job">


        <div class="">
          <form className="form" action="POST" onSubmit={handlesubmit}>
            <input
              aria-label="Name"
              name="fullname"
              type="text"
              className="form-control"
              placeholder="Enter Full Name"
              onChange={handlechange}
              value={data.fullname}
              required
            />

            <input
              aria-label="Email"
              name="email"
              type="email"
              className="form-control"
              placeholder="Enter Email"
              required
              onChange={handlechange}
              value={data.email}
            />

            <input
              aria-label="Mobile Number"
              type="number"
              name="number"
              className="form-control"
              placeholder="Mobile Number"
              required
              onChange={handlechange}
              value={data.number}
            />

            <select
              name="course"
              id="areaOfInterest"
              onChange={handlechange}
              value={data.course}
              required>
              <option value="" disabled>Select Course</option>
              <option value="Full Stack Web Development">Full Stack Web Development</option>
              <option value="AI & ML">AI & ML</option>
              <option value="Java Full Stack">Java Full Stack</option>
              <option value="Cloud Architect & AWS">Cloud Architect & AWS</option>
              <option value="Python & Data Science">Python & Data Science</option>
            </select>

            <textarea
              type="text"
              name="message"
              className="form-control"
              placeholder="(Optional) Type your message here..."
              onChange={handlechange}
              value={data.message}
            ></textarea>

            {error && <p className="error-textapply">{error}</p>}

            <button type="submit" aria-label="Create Account">
              Apply
            </button>
          </form>
        </div>
        {submissionpage &&
          <ManualAlertpage
            message={Submissiondata.message}
            context={Submissiondata.context}
            context2={Submissiondata.context2}
            btnname={Submissiondata.btnname}
            close={submissionpage}
            togglebox={toggleFn} />
        }
      </section>
    </>
  )
};

export default ApplyCourse;
